import { render, staticRenderFns } from "./trajectory-enrolments-result.vue?vue&type=template&id=88fa95f6&scoped=true"
import script from "./trajectory-enrolments-result.vue?vue&type=script&lang=js"
export * from "./trajectory-enrolments-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fa95f6",
  null
  
)

export default component.exports